import ProjectService from '../../project.service.js';
import Service from '@/service/index.js';
import Pagination from '@/components/pagination/index.vue';
import {transactionProjectStatus} from '@/utils/mixins/transaction-project-status.js';
import extendAnnouncementMixins from '@/utils/mixins/extend-announcement.js';
// import { errorMessage, successMessage } from '@/utils/message.js';
import Payment from '@/components/payment/payment.vue';
import { changeSkin } from '@/utils/common.js';
export default {
  components: {
    Pagination,
    Payment
  },
  mixins: [transactionProjectStatus, extendAnnouncementMixins],
  data() {
    return {
      projectStatusArr: [],
      projectTypeArr: [],
      tradeTypeArr: [],
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tableList: [],
      showPayment: false,
      currentProjectId: ''
    };
  },
  created() {
    const arr = [
      ['projectStatusArr', 'PROJECT_STATUS'],
      ['projectTypeArr', 'PROJECT_TYPE'],
      ['tradeTypeArr', 'TRADE_TYPE']
    ];
    arr.forEach((value) => {
      if (!value.length) {
        return;
      }
      Service.getSelectList(value[1]).then(res => {
        if (res && res.code === '0') {
          this[value[0]] = res.data;
        }
      });
    });
    this.getRollOutProjectList();
  },
  computed: {
  },
  methods: {
    changeSkin,
    // 项目类型两级拼接
    projectTypeText (projectItem) {
      if (!this.projectTypeArr.length) {return ''; }
      const obj = this.projectTypeArr.find(item => item.code === String(projectItem.projectType));
      if (obj) {
        const subObj = obj.list && obj.list.find(item => item.code === String(projectItem.projectSubType));
        if (subObj) {
          return obj.value + ' · ' + subObj.value;
        } else {
          return obj.value;
        }
      } else {
        return '';
      }
    },
    // 获取发布项目列表
    getRollOutProjectList(page){
      // console.log(page, 'page');
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      ProjectService.getRollOutProjectList(this.currentPage, this.pageSize).then(res => {
        if (res && res.code === '0') {
          this.total = res.data.total;
          this.tableList = res.data.list;
        }
      });
    },
    goToDetail (item) {
      window.open(window.location.origin + '/#/person-center/project/roll-out-project/detail?id=' + item.id + '&specialStatus=' + item.specialStatus);
    },
    // confirmProjectById (id) {
    //   ProjectService.confirmProjectById(id).then(res => {
    //     if (res && res.code === '0') {
    //       successMessage('确认公告成功');
    //       this.getRollOutProjectList();
    //     } else if (res && res.reason) {
    //       errorMessage(res && res.reason);
    //     } else {
    //       errorMessage('确认公告失败');
    //     }
    //   }, (error) => {
    //     if (error && error.data && error.data.reason) {
    //       errorMessage(error.data.reason);
    //     } else {
    //       errorMessage('确认公告失败');
    //     }
    //   });
    // },
    paymentSuccess () {
      this.getRollOutProjectList();
    },
    dispose (item) {
      console.log(item);
      this.$router.push('/person-center/project/roll-out-project/trans?id=' + item.id + '&tradeType=' + item.tradeType);
    },
    // 发布协议交易项目
    publishProject () {
      // 交易方式 1公开交易 2协议交易
      this.$store.commit('SET_TRADE_TYPE', 2);
      window.open(window.location.origin + '/#/publish-project/project-info?tradeType=2');
    },
    // 发布协议交易项目
    batchProject () {
      // 交易方式 3 发布批量协议交易
      this.$store.commit('SET_TRADE_TYPE', 3);
      window.open(window.location.origin + '/#/publish-project/project-batchinfo?tradeType=3');
    }
  }
};
